// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"53":"87c532c3","156":"5cfe50c8","213":"44bc9ff8","221":"4af3dc0d","245":"7ef6269e","429":"44bc9ff8","533":"cab74a05","712":"a14f4e0e"}[chunkId] + ".chunk.css";
};